import { FC } from 'react';
import { ProductoData } from '../../model/ProductoData';
import { NumberFormat } from '../../config/NumberFormat';
import { ResumenBase } from './ResumenBase';
import { ProductConfig } from './ProductConfig';

type Props = {
  product?: ProductoData | undefined;
  productConfig?: ProductConfig;
};

export const ProductoResumen: FC<Props> = ({ product, productConfig }) => {
  if (!product || !productConfig?.productoResumenParte1) return <></>;

  return (
    <ResumenBase>
      {/*Frase inicial que depende del tipo de producto*/}
      {productConfig.productoResumenParte1}
      {/*Puntaje */}
      <b> {NumberFormat.formatNumber(product.puntos)}</b>
      &thinsp;
      {product.puntos === 1 ? 'punto ' : 'puntos '}
      {/*Nombre del producto*/}
      por {productConfig.productoResumenParte2}&thinsp;
      <b>{product.titulo}</b>.
    </ResumenBase>
  );
};
